// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verificationContainer {
    width: 100%;
    min-height: 100vh;
    background: #0c0b20;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 40px 0px;
}

.verificationContent {
    display: flex;
    flex: 1 1;
    width: 100%;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 500px;
}

.verificationContent p:nth-child(1) {
    font-size: 20px;
    text-align: center;
    width: 100%;
}


.verificationContent p:nth-child(2) {
    font-size: 14px;
    text-align: center;
    width: 100%;
    margin-bottom: 32px;
}

.verificationContent form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
}

.verificationContent form input {
    display: flex;
    padding: 10px 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 10px;
    background: #FFF;
    border: none;
}

.verificationContent form button {
    display: flex;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 32px;
background: #C3D32C;
font-size: 16px;
border: none;
color: #000;
}`, "",{"version":3,"sources":["webpack://./src/assets/Styles/Verification.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB,mBAAmB;AACnB,eAAe;AACf,YAAY;AACZ,WAAW;AACX","sourcesContent":[".verificationContainer {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background: #0c0b20;\r\n    color: white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 40px 0px;\r\n}\r\n\r\n.verificationContent {\r\n    display: flex;\r\n    flex: 1;\r\n    width: 100%;\r\n    padding: 16px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 16px;\r\n    max-width: 500px;\r\n}\r\n\r\n.verificationContent p:nth-child(1) {\r\n    font-size: 20px;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.verificationContent p:nth-child(2) {\r\n    font-size: 14px;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-bottom: 32px;\r\n}\r\n\r\n.verificationContent form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    gap: 8px;\r\n}\r\n\r\n.verificationContent form input {\r\n    display: flex;\r\n    padding: 10px 12px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    align-self: stretch;\r\n    border-radius: 10px;\r\n    background: #FFF;\r\n    border: none;\r\n}\r\n\r\n.verificationContent form button {\r\n    display: flex;\r\n    padding: 12px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 4px;\r\n    align-self: stretch;\r\n    border-radius: 32px;\r\nbackground: #C3D32C;\r\nfont-size: 16px;\r\nborder: none;\r\ncolor: #000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
